import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 p-4 relative min-h-300" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center gap-2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Loading addresses...", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, " Select an address to create a shipment. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Then add mails for shipping.", -1)
const _hoisted_6 = { class: "flex items-center gap-5 justify-center mt-auto" }
const _hoisted_7 = {
  key: 2,
  class: "m-auto flex flex-col items-center gap-4"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, " You have no virtual mails addresses. ", -1)

import {
	Dialog,
	UiButton,
	SvgIcon,
	UiSelect,
	UiLoader,
	UiFormError
} from '@/ui-kit';
import { useToggle } from '@vueuse/core';
import { useVirtualMailboxAddresses } from '../use-virtual-mailbox-addresses';
import { ref } from 'vue';
import { useVirtualMailboxShipments } from '../use-virtual-mailbox-shipments';
import { AxiosError } from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddShipmentDialog',
  props: {
    mailboxId: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	mailboxId: number;
};

const [isOpened, setIsOpened] = useToggle();
const [loading, setLoading] = useToggle();
const { loadAddresses, addressOptions, isLoading } =
	useVirtualMailboxAddresses();
const { createShipment } = useVirtualMailboxShipments();
const selectedAddress = ref(0);



const error = ref('');

const onError = (e: AxiosError) => {
	if (!e.response || !e.response.data) {
		return;
	}

	if (e.response.data.error || e.response.data.message) {
		error.value =
			e.response.data.error ||
			e.response.data.message;
	}

	if (e.response.data.errors) {
		error.value = e.response.data.message || '';
	}
};

async function create() {
	setLoading(true);
	try {
		await createShipment(
			props.mailboxId,
			selectedAddress.value
		);

		setIsOpened(false);
	} catch (e) {
		onError(e as AxiosError);
		setLoading(false);
	}
}

expose({
	openDialog: async () => {
		error.value = '';
		setLoading(false);
		setIsOpened(true);
		await loadAddresses();
		selectedAddress.value =
			addressOptions.value[0]?.value || (0 as any);
	}
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    preventDefaultClose: _unref(loading),
    modelValue: _unref(isOpened),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(setIsOpened)(false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_unref(UiLoader))
            ]))
          : (_unref(addressOptions).length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_4,
                _hoisted_5,
                _createVNode(_unref(UiSelect), {
                  modelValue: selectedAddress.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAddress).value = $event)),
                  options: _unref(addressOptions),
                  placeholder: "Address"
                }, null, 8, ["modelValue", "options"]),
                _createVNode(_unref(UiFormError), { errorMessage: error.value }, null, 8, ["errorMessage"]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(UiButton), {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setIsOpened)(false))),
                    theme: "primary-outlined",
                    type: "button",
                    class: "!text-sm !h-10 !min-w-20 w-32 !px-0",
                    disabled: _unref(loading)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_unref(UiButton), {
                    onClick: create,
                    class: "!text-sm !h-10 !min-w-20 w-32 !px-0",
                    loading: _unref(loading)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Create Shipment ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createVNode(_component_RouterLink, { to: "/app/settings/virtual-mailbox/addresses?openDialog" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UiButton), {
                      class: "!text-sm !h-10 !px-2",
                      theme: "transparent"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SvgIcon), {
                          class: "h-5 w-5 mr-2",
                          name: "only-plus"
                        }),
                        _createTextVNode("Add address ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
      ])
    ]),
    _: 1
  }, 8, ["preventDefaultClose", "modelValue"]))
}
}

})